import React from 'react';
import useDataSourceContext from '../../DataSource/useDataSourceContext';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Hidden from '@material-ui/core/Hidden';
import IconButton from '@material-ui/core/IconButton';
import Icon from '../../Icon';
import View from './View';

const DataListViews = () => {
  const { setShowViewsSelection, views: viewsModule = {} } = useDataSourceContext();
  const { activeView = {}, fixedViews = [], setActiveView, getAvailableViews } = viewsModule;
  const availableViews = (getAvailableViews && getAvailableViews()) || [];
  const visibleViews = [...fixedViews, ...(availableViews ?? [])];

  const handleOpenViewsDrawer = () => {
    setShowViewsSelection(true);
  };

  const handleToggleView = key => () => {
    setActiveView(key === activeView?.key ? 'default' : key);
  };

  return (
    <>
      <Hidden implementation="js" smDown>
        {visibleViews.map(view => (
          <Box px={0.5} py={2} key={view?.key}>
            <Chip
              label={view?.name}
              variant={activeView?.key === view?.key ? 'default' : 'outlined'}
              onClick={handleToggleView(view?.key)}
              color="primary"
            />
          </Box>
        ))}
      </Hidden>
      <Hidden implementation="js" mdUp>
        <IconButton onClick={handleOpenViewsDrawer}>
          <Icon icon={['fal', 'eye']} />
        </IconButton>
        {activeView?.key && (
          <Box p={0.5} key={activeView?.key} flex={1}>
            <View
              label={activeView?.name}
              variant="default"
              onClick={handleOpenViewsDrawer}
              color="primary"
            />
          </Box>
        )}
      </Hidden>
    </>
  );
};

export default DataListViews;
